import { Button } from "@/components/common/Button/Button"
import { PickingSparklingBirdIcon } from "@/components/common/icons/PickingSparklingBirdIcon/PickingSparklingBirdIcon"
import { ModalBase } from "@/components/common/ModalBase/ModalBase"
import { Typography } from "@/components/common/Typography/Typography"
import useFreeTrial from "@/hooks/useFreeTrial"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { URLS } from "@/utils/urls.const"
import { useState } from "react"

const FEEDBACK_MODAL_STORAGE_KEY = "turnus-feedback-modal-shown"
const FEEDBACK_MODAL_SHOW_ON_LEFT_DAYS = 3

interface FeedbackModalViewProps {
  onClose: () => void
  translations: {
    title: string
    description: string
    primaryAction: string
  }
}

export const FeedbackModalView: React.FC<FeedbackModalViewProps> = ({
  onClose,
  translations,
}) => (
  <ModalBase showSidebarLeft onClose={onClose}>
    <div className="flex min-h-full flex-col items-center justify-center gap-8">
      <PickingSparklingBirdIcon />
      <div className="flex max-w-[500px] flex-col gap-4 text-center">
        <Typography variant="titleM">{translations.title}</Typography>
        <Typography variant="textM">{translations.description}</Typography>
      </div>
      <a href={URLS.GIVE_FEEDBACK}>
        <Button
          label=""
          title={translations.primaryAction}
          variantSize="medium"
          variantColor="yellow"
          onClick={() => {}}
        />
      </a>
    </div>
  </ModalBase>
)

export const FeedbackModal: React.FC = () => {
  const { translate } = useTranslation()
  const { left } = useFreeTrial()
  const [isModalShown, setIsModalShown] = useState(
    localStorage.getItem(FEEDBACK_MODAL_STORAGE_KEY) !== null,
  )

  if (shouldHideModal(isModalShown, left)) {
    return undefined
  }

  const handleClose = () => {
    localStorage.setItem(FEEDBACK_MODAL_STORAGE_KEY, "true")
    setIsModalShown(true)
  }

  const translations = {
    title: translate("FEEDBACK_MODAL/TITLE"),
    description: translate("FEEDBACK_MODAL/DESCRIPTION"),
    primaryAction: translate("FEEDBACK_MODAL/PRIMARY_ACTION"),
  }

  return <FeedbackModalView onClose={handleClose} translations={translations} />
}

function shouldHideModal(isModalShown: boolean, left: number) {
  return isModalShown || !(left <= FEEDBACK_MODAL_SHOW_ON_LEFT_DAYS && left > 0)
}
